import type { ApiParams, ApiResponse, CustomerResetPasswordResponse, SetNewPasswordParams } from '~/utils/ct';
import { useExpondoMiddleware } from '~/composables';
import { EXPONDO_MIDDLEWARE_ROUTES } from '~/constants/routes';

export function useForgotPasswordApi() {
  const { makeCommercetoolsRequest } = useExpondoMiddleware();

  const setNewPassword = async ({ tokenValue, newPassword, customQuery }: ApiParams<SetNewPasswordParams>):
    Promise<ApiResponse<CustomerResetPasswordResponse> | null> => {
    const setNewPasswordResult = await makeCommercetoolsRequest<CustomerResetPasswordResponse>({
      endpoint: EXPONDO_MIDDLEWARE_ROUTES.CT.RESET_PASSWORD,
      data: [
        tokenValue, newPassword, customQuery,
      ],
    });
    return setNewPasswordResult;
  };

  return {
    setNewPassword,
  };
}
